import { useState, useEffect } from "react";
import "./index.css";
import { API_BASE } from "./config";
import { PageLogin } from "./PageLogin";
import { PageGallery } from "./PageGallery";

export function App() {
  const [userId, setUserId] = useState<number | null>(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/api/auth/me`, { credentials: "include" })
      .then((res) => {
        if (res.ok) return res.json() as Promise<{ userId: number }>;
        setUserId(null);
        return null;
      })
      .then((data) => {
        if (data?.userId != null) setUserId(data.userId);
        setAuthChecked(true);
      })
      .catch(() => {
        setUserId(null);
        setAuthChecked(true);
      });
  }, []);

  const handleLoginSuccess = () => {
    location.assign(location.origin);
  };

  if (!authChecked) {
    return (
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center gap-4">
        <div className="w-10 h-10 border-2 border-[var(--wedding-gold)] border-t-transparent rounded-full animate-spin" />
        <p className="text-[var(--wedding-ink-muted)]">Wird geladen…</p>
      </div>
    );
  }

  if (userId === null) {
    return <PageLogin onSuccess={handleLoginSuccess} />;
  }

  return <PageGallery />;
}

export default App;
